import { httpClient } from '../httpClient/httpClient';
import { SimpleFileLink } from './filesApi';
import { ComplianceDocumentKind } from './metadata/complianceDocumentDefinitionsApi';

export interface SupplierComplianceDocumentFile {
  id: number;
  name: string;
  originalName: string;
  identifier: string;
  extension: string;
  size: number;
  archived: boolean;
}

export interface SupplierComplianceDocumentBranch {
  id: number;
  name: string;
  identifier: string;
}

export interface SupplierComplianceDocument {
  id: number;
  supplierId: number;
  complianceDocumentDefinitionId: number;
  definitionName: string;
  definitionKind: ComplianceDocumentKind;
  definitionLogo: SimpleFileLink | null;
  label: string | null;
  description: string | null;
  startDate: string | null;
  endDate: string | null;
  created: string;
  updated: string;
  archived: string | null;
  file: SupplierComplianceDocumentFile;
  branches: SupplierComplianceDocumentBranch[];
}

export interface SupplierComplianceDocumentSearchRequest {
  supplierId: number;
  searchTerm?: string;
  includeArchived?: boolean;
  sortBy?: string;
  sortDesc?: boolean;
}

export interface SupplierComplianceDocumentList {
  items: SupplierComplianceDocument[];
}

export interface CreateSupplierComplianceDocumentRequest {
  supplierId: number;
  complianceDocumentDefinitionId: number;
  fileLinkId: number;
  label: string | null;
  description: string | null;
  startDate: string | null;
  endDate: string | null;
  branchIds: number[];
}

export interface UpdateSupplierComplianceDocumentRequest {
  complianceDocumentDefinitionId: number;
  fileLinkId: number | null;
  label: string | null;
  description: string | null;
  startDate: string | null;
  endDate: string | null;
}

export interface UpdateSupplierComplianceDocumentBranchesRequest {
  branchIds: number[];
}

export const supplierComplianceDocumentsApi = {
  search: (request: SupplierComplianceDocumentSearchRequest) =>
    httpClient.post<SupplierComplianceDocumentList>(
      'supplier-compliance-documents/search',
      { data: request },
    ),
  create: (request: CreateSupplierComplianceDocumentRequest) =>
    httpClient.post<SupplierComplianceDocument>(
      'supplier-compliance-documents',
      { data: request },
    ),
  update: (id: number, request: UpdateSupplierComplianceDocumentRequest) =>
    httpClient.put<SupplierComplianceDocument>(
      `supplier-compliance-documents/${id}`,
      { data: request },
    ),
  updateBranches: (
    id: number,
    request: UpdateSupplierComplianceDocumentBranchesRequest,
  ) =>
    httpClient.put<SupplierComplianceDocument>(
      `supplier-compliance-documents/${id}/branches`,
      { data: request },
    ),
};
